module.exports = __webpack_public_path__ + "img/41GeorgeHWBush.4b3c4708.png";